import { lazy } from 'react';
import reducer from './state/reducers'
import { getStore } from '@AppRedux/store';
import checkAuth from '@Utils/checkAuth';

const store = getStore();

const ApplicationFormList = lazy(() =>
    import(/* webpackChunkName: "hrPafList" */ './PublicApplicationFormList').then(async module => {
        // wait for fetching userinfo before rendering
        await checkAuth();
        const auth = getStore().getState().auth;
        if (auth.isAuthenticated) {
            // Register list reducer together with publicAF List Route
            store.injectReducer('publicAFList', reducer.listReducer);
            return module;
        }
    })
);

const ApplicationFormAdd = lazy(() => //HR view
    import('./PublicApplicationFormAdd').then(async module => {
        // // wait for fetching userinfo before rendering
        await checkAuth();
        const auth = getStore().getState().auth;
        if (auth.isAuthenticated) {
            // Register add reducer together with PublicAF add Route
            store.injectReducer('publicAFAdd', reducer.addReducer);
            return module;
        }
    }
    )
);

const PublicApplicationFormAdd = lazy(() => //Public view
    import('./PublicApplicationFormAdd').then(module => {
        // Register add reducer together with PublicAF add Route
        store.injectReducer('publicAFAdd', reducer.addReducer);
        return module;
    })
);

const PublicApplicationFormDetails = lazy(() => //Public view
    import('./PublicApplicationFormDetails').then(module => {
        // Register detail reducer together with PublicAF add Route
        store.injectReducer('publicAFDetails', reducer.detailReducer);
        return module;
    })
);

const ApplicationFormDetail = lazy(() =>
    import('./PublicApplicationFormDetails').then(async module => {
        // // wait for fetching userinfo before rendering
        await checkAuth();
        // // Only show HR PAF List page if user loggedin is authenticated
        const auth = getStore().getState().auth;
        if (auth.isAuthenticated) {
            // Register detail reducer together with PublicAF add Route
            store.injectReducer('publicAFDetails', reducer.detailReducer);
            return module;
        }
    }))

const PublicApplicationFormRoutes = [
    {
        label: 'Application Form',
        path: '/HRAutomation/ApplicationForm',
        menuName: 'publicApplicationForm',
        component: ApplicationFormList,
        icon: 'fa-list',
        exact: true,
        showNav: true, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    },
    {
        label: 'Application Form',
        path: '/HRAutomation/ApplicationForm/Add',
        component: ApplicationFormAdd,
        exact: true,
        showNav: false, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    },
    {
        label: 'Application Form',
        path: '/apply/applicationform',
        component: PublicApplicationFormAdd,
        exact: true,
        showNav: false, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    },
    {
        label: 'Application Form',
        path: '/HRAutomation/ApplicationForm/:mode/:id',
        component: ApplicationFormDetail,
        exact: true,
        showNav: false, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    },
    {
        label: 'Public Application Form',
        path: '/applicantdetails',
        component: PublicApplicationFormDetails,
        exact: true,
        showNav: false, //if true, displays the label in the mainHeader.js component
        public: true, // TODO: remove for private route
    },
]

export default PublicApplicationFormRoutes;